import React, { useState, useEffect } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Loader from '../../Components/Utility/Loader/Loader';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function ProductStatusMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { productStatusList } = SystemMastersDetails;
  const { userInfo } = UserDetails;
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  const productStatusType = 'product-status-type';
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);

  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'prodStatus', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'prodStatus', 'delete');
  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingPSM, setIsLoadingPSM] = useState(false);
  const [showPSM, setShowPSM] = useState(false);
  const [isPSUnique, setIsPSUnique] = useState(true);
  const [buttonDownPsm, setButtonDownPsm] = useState(true);
  const [psmBtnDisable, setPsmBtnDisable] = useState(false);
  const [addingPSM, setAddingPSM] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isPSM, setIsPSM] = useState(false);
  const [productStatusData, setProductStatusData] = useState([]);
  const [isUniqPsId, setIsUniqPsId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [isSelected, setisSelected] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [scrollEl, setScrollEl] = useState();
  const [pendingPimStatusIds, setPendingPimStatusIds] = useState(new Set());
  const [pimStatusDirty, setPimStatusDirty] = useState(false);

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  useEffect(() => {
    setProductStatusData(productStatusList);
    if (addingPSM) {
      setProductStatusData([
        ...productStatusList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
    if (!pimStatusDirty) {
      setPendingPimStatusIds(new Set());
    }
  }, [productStatusList, addingPSM, pimStatusDirty]);

  const callApi = async () => {
    setButtonDownPsm(!buttonDownPsm);
    setIsLoadingPSM(true);
    buttonDownPsm ? setShowPSM(true) : setShowPSM(false);
    const psParams = {
      loggedInUserId,
    };
    if (isEmpty(productStatusData)) {
      await dispatch(action.getProductStatusDetails(psParams));
    }
    setIsLoadingPSM(false);
  };

  const handleChanged = (event, i) => {
    const PSM = [...productStatusData];
    setIsPSUnique(true);
    setIsUniqPsId([]);
    const newValue = event?.target?.value;
    PSM[i] = {
      ...PSM[i],
      name: newValue,
      isEmpty: isEmpty(newValue?.toString()?.trim()),
    };
    const arr = [];
    const arrIndex = [];
    PSM.forEach((ele, ind) => {
      const n1 = ele?.name?.toString()?.trim()?.toLowerCase() || '';
      if (n1 === '') return; // ignore empty while checking duplicates
      PSM.forEach((objs, index) => {
        if (ind === index) return;
        const n2 = objs?.name?.toString()?.trim()?.toLowerCase() || '';
        if (n2 === '') return; // ignore empty while checking duplicates
        if (n1 === n2) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqPsId([...newArr]);
    }
    setIsPSUnique(isEmpty(arr));
    let isDisableLength = false;
    PSM.forEach((lensElement) => {
      if (isEmpty(lensElement?.name?.toString()?.trim())) {
        isDisableLength = true;
      }
    });
    setPsmBtnDisable(isDisableLength);
    setProductStatusData(PSM);
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      productStatusData.splice(id, 1);
      productStatusData.forEach((psmElement) => {
        if (isEmpty(psmElement?.name?.trim()) && psmElement.isNew) {
          setPsmBtnDisable(true);
        } else {
          setPsmBtnDisable(false);
        }
      });
      setIsUniqPsId([]);
      setIsPSUnique(true);
      setProductStatusData([...productStatusData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveProductStatus = async () => {
    setIsPSM(true);
    if (!isEmpty(productStatusData)) {
      const emptyField = await productStatusData.filter((psitem) => psitem.name === null || psitem.name === '');

      if (isEmpty(emptyField)) {
        const data = productStatusData.map((psobj) => {
          return { ...psobj, name: psobj?.name?.trim() };
        });
        const productParams = {
          title: productStatusType,
          loggedInUserId,
          names: JSON.stringify(data),
        };
        if (pimStatusDirty && pendingPimStatusIds.size > 0) {
          productParams.pimStatusTypeIds = [...pendingPimStatusIds];
        }

        setAddingPSM(false);
        await dispatch(action.saveToSystemMaster(productParams, t));
        if (pimStatusDirty) {
          setPimStatusDirty(false);
          setPendingPimStatusIds(new Set());
        }
        const psParams = {
          loggedInUserId,
        };
        await dispatch(action.getProductStatusDetails(psParams));
      } else {
        const newState = productStatusData.map((posobj) => (posobj?.isEmpty === false && posobj.name === null ? { ...posobj, isEmpty: true } : posobj));
        setProductStatusData(newState);
      }
    }
    setIsPSM(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    if (productStatusData && productStatusData.length > 0) {
      productStatusData.forEach((ele, index) => {
        const n1 = ele?.name?.toString()?.trim()?.toLowerCase() || '';
        if (n1 === '') return; // ignore empties
        productStatusData.forEach((obj, places) => {
          if (index === places) return;
          const n2 = obj?.name?.toString()?.trim()?.toLowerCase() || '';
          if (n2 === '') return; // ignore empties
          if (n1 === n2) {
            array.push(ele);
          }
        });
      });
    }
    if (isEmpty(array)) {
      setIsPSUnique(true);
      setIsUniqPsId([]);
    }
  }, [productStatusData]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const productStatusMasterParams = {
      loggedInUserId,
      productStatusTypeId: deleteId,
      title: productStatusType,
    };
    await dispatch(action.deleteFromSystemMasters(productStatusMasterParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setProductStatusData([...productStatusList]);
    const psParams = {
      loggedInUserId,
    };
    await dispatch(action.getProductStatusDetails(psParams));
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let psm = {};
    productStatusData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: productStatusType,
        };
        psm = data;
      }
    });
    await dispatch(action.setActiveInactive(psm, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setProductStatusData([...productStatusData]);
  };

  const addProductStatus = async () => {
    if (!showPSM) {
      setAddingPSM(true);
      setButtonDownPsm(!buttonDownPsm);
      setIsLoadingPSM(true);
      buttonDownPsm ? setShowPSM(true) : setShowPSM(false);
      const psParams = {
        loggedInUserId,
      };
      isEmpty(productStatusData) && (await dispatch(action.getProductStatusDetails(psParams)));
      setIsLoadingPSM(false);
    } else if (!isEmpty(productStatusData)) {
      setProductStatusData([...productStatusData, tempObj]);
    } else {
      setProductStatusData([tempObj]);
    }
  };

  const renderTooltipOpenClosePsm = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownPsm ? t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.CLOSE') : t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.OPEN')}
    </Tooltip>
  );

  const btnCall = () => {
    if (buttonDownPsm === false) {
      return <i className="icon-new-up" />;
    }
    return <i className="icon-new-down" />;
  };

  const handleRadioButton = async (e) => {
    setisSelected(e.target.value);
    const setDefaultParams = {
      isDefault: true,
      productStatusTypeId: e.target.value,
    };
    await dispatch(action.setProductStatus(setDefaultParams, t));
  };

  /**
   * Toggle a newly-checked PIM status. Already-persisted statuses (pimStatus: true in DB)
   * are locked and cannot be unchecked. Pending selections can be toggled before Save.
   */
  const handlePimStatusCheckbox = (statusId, alreadyPersisted) => {
    if (!statusId || alreadyPersisted) return;
    setPendingPimStatusIds((prev) => {
      const next = new Set(prev);
      if (next.has(statusId)) {
        next.delete(statusId);
      } else {
        next.add(statusId);
      }
      return next;
    });
    setPimStatusDirty(true);
  };

  const renderTooltipPimStatusDefault = (props) => (
    <Tooltip id="button-tooltip-pim-status" {...props}>
      {t('systemMaster:PRODUCT_STATUS_MASTER.PIM_DEFAULT_STATUS_TOOLTIP')}
    </Tooltip>
  );

  const renderTooltipPimStatusLocked = (count) => function(props) {
  return <Tooltip id="button-tooltip-pim-status-locked" {...props}>
        {t('systemMaster:PRODUCT_STATUS_MASTER.PIM_DEFAULT_STATUS_LOCKED_TOOLTIP', { count })}
      </Tooltip>
};

  const renderPimStatusCheckbox = (item, i) => {
    if (!item || item._id === '' || !MasterAddEditAccess) return null;
    const alreadyPersisted = item?.pimStatus === true;
    const isPending = pendingPimStatusIds.has(item._id);
    const isChecked = alreadyPersisted || isPending;
    const lockedCount = item?.lockedProductCount || 0;
    const tooltipRenderer = alreadyPersisted
      ? renderTooltipPimStatusLocked(lockedCount)
      : renderTooltipPimStatusDefault;
    return (
      <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={tooltipRenderer}>
        <div className="common-checkbox">
          <input
            type="checkbox"
            id={`pim_status_${i}`}
            value={item._id}
            onChange={() => handlePimStatusCheckbox(item._id, alreadyPersisted)}
            disabled={alreadyPersisted}
            checked={isChecked}
          />
          <label className="chklabel mb-0" htmlFor={`pim_status_${i}`}>
            <span className="sr-only">PIM eligible</span>
          </label>
        </div>
      </OverlayTrigger>
    );
  };

  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.ACTIVE_INACTIVE')}
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.DELETE')}
    </Tooltip>
  );

  const psms = () => {
    return isPSM ? (
      <Spinner animation="border" />
    ) : (
      <>
        <span className="icon-Save c-button-align f-20 mr-2" /> {t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.SAVE')}
      </>
    );
  };

  return (
    <>
      <Accordion className="mb-4 master-accordian">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('PRODUCT_STATUS_MASTER.TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <BtnAdd onBtnClick={addProductStatus} forDisable={psmBtnDisable || !isPSUnique} addEditAccess={MasterAddEditAccess} />
              <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenClosePsm}>
                <button type="button" onClick={() => callApi()}>
                  {btnCall()}
                </button>
              </OverlayTrigger>
            </div>
          </Card.Header>
          {showPSM &&
            (isLoadingPSM ? (
              <Loader />
            ) : (
              <Card.Body>
                <PerfectScrollbar containerRef={(ref) => setScrollEl(ref)}>
                  <ul>
                    {!isEmpty(productStatusData) &&
                      productStatusData.map((item, i) => {
                        return (
                          <li key={`${item?._id || 'new'}-${i}`}>
                            <div className="input-container">
                              <div className="d-flex">
                                <div className="custom-radio">
                                  <input
                                    type="radio"
                                    id={`status_${i}`}
                                    value={item._id}
                                    onChange={handleRadioButton}
                                    disabled={!MasterAddEditAccess}
                                    checked={isSelected ? item._id === isSelected : item.isDefault === true}
                                  />
                                  <label className="mb-0" htmlFor={`status_${i}`}>
                                    &nbsp;
                                  </label>
                                </div>
                                <input
                                  name="productStatusMaster"
                                  value={item?.name !== undefined && item?.name !== null ? item?.name : ''}
                                  autoFocus={!item?._id}
                                  placeholder={t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.ENTER_PRODUCT_STATUS_MASTER')}
                                  type="text"
                                  onChange={(e) => handleChanged(e, i)}
                                  disabled={!MasterAddEditAccess}
                                />
                              </div>
                              {item.isEmpty && (item.name === null || item.name === '') && (
                                <label htmlFor="productStatusMaster" className="text-danger m-0 p-1">
                                  {t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.PRODUCT_STATUS_ENTRY_REQUIRED')}
                                </label>
                              )}
                              {!isEmpty(isUniqPsId) && isUniqPsId?.includes(i) && (
                                <label htmlFor="productStatusMaster" className="text-danger m-0 p-1">
                                  {t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.ENTRY_ALREADY_EXIST')}
                                </label>
                              )}

                              {item.isNew && !isEmpty(item?.name) && isEmpty(item?.name?.trim()) && (
                                <label htmlFor="productStatusMaster" className="text-danger m-0 p-1">
                                  {t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.PRODUCT_STATUS_ENTRY_INVALID')}
                                </label>
                              )}
                            </div>
                            <div className="input-action">
                              {renderPimStatusCheckbox(item, i)}
                              {item?._id !== '' && MasterAddEditAccess && (
                                <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
                                  <button aria-label="active" type="button" onClick={() => activeInactiveClicked(item._id)} id={item._id}>
                                    <span className={item.isActive ? 'icon-active' : 'icon-inactive'} />
                                  </button>
                                </OverlayTrigger>
                              )}
                              {MasterDeleteAccess ? (
                                <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
                                  <button aria-label="delete" type="button" onClick={() => handleDelete(item._id ? item._id : i)}>
                                    <span className="icon-delete mt-3 f-20" />
                                  </button>
                                </OverlayTrigger>
                              ) : (
                                ''
                              )}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </PerfectScrollbar>
                <div className="section-save">
                  {MasterAddEditAccess && (
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button
                        aria-label="Save"
                        type="button"
                        className="btn btn-page-filter btn-white"
                        onClick={saveProductStatus}
                        disabled={psmBtnDisable || !isPSUnique}
                      >
                        {psms()}
                      </button>
                    </CustomTooltip>
                  )}
                </div>
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.TITLE')}
          message={t('PRODUCT_STATUS_MASTER.DELETE_CONFIRMATION.MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('PRODUCT_STATUS_MASTER.ACTIVE_INACTIVE_CONFIRMATION.TITLE')}
          message={t('PRODUCT_STATUS_MASTER.ACTIVE_INACTIVE_CONFIRMATION.MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default ProductStatusMaster;
